module.exports = __webpack_public_path__ + "static/media/1342_discharge2_HL.5aef9fef.png";